import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";

export default class SubTransactionType extends BaseInstitutionEntity {
    code: string = '';
    description: string = '';
}
